const BLOCK_PRIORITY_BASE = 10000

export function getScrollTriggerRefreshPriority(element, fallback = 0) {
    const block = element?.closest?.('[data-block-index]')
    const blockIndex = Number.parseInt(block?.dataset?.blockIndex, 10)

    if (!Number.isFinite(blockIndex)) return fallback

    return BLOCK_PRIORITY_BASE - blockIndex
}
